import { styled } from '@abyss/web/tools/styled';
import { Button } from '@abyss/web/ui/Button';
import { Flex } from '@abyss/web/ui/Flex';
import { Text } from '@abyss/web/ui/Text';

export const ChooseLocationPopupContainer = styled(Flex, {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '8px',
  width: '161px',
  padding: '8px',
  border: '1px solid $grey3',
  borderRadius: '8px',
  background: '#FFF',
});

export const ChooseLocationMainContainer = styled(Flex, {
  '&.abyss-flex-root': {
    width: '161px',
  },
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '8px',
  alignSelf: 'stretch',
});

export const ChooseLocationProvider = styled(Text, {
  fontWeight: '700',
  'abyss-text-root': {
    alignSelf: 'stretch',
    fontSize: '14px',
    fontWeight: '700',
    lineHeight: '18px',
    color: '$grey8',
  },
});

export const ChooseLocationTile = styled(Flex, {
  width: '151px',
  gap: '4px',
  alignSelf: 'stretch',
});

export const ChooseLocationAddress = styled(Text, {
  display: 'webkit-box',
  webkitLineClamp: '1',
  webkitBoxOrient: 'vertical',
  alignSelf: 'stretch',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  '&.abyss-text-root': {
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '18px',
    color: '#323334',
  },
});

export const ChooseLocationButton = styled(Button, {
  '&.abyss-button-root': {
    padding: '0px',
    textAlign: 'start',
    height: 'auto'
  },
});
